export const SelectTaxBasis  =
  [{ id: 1, name: "Ignore Tax" },
  { id: 2, name: "Default Rate" },
  //{ id: 3, name: "Extracted Amount" }
  ]

export const PasswordPatternConst = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%&*_])[A-Za-z\d~!@#$%&*_].{8,125}$/;
